import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import EditableLabel from 'APP_ROOT/components/EditableLabel';
import { DispatchHelpers as AssetMonitoringDispatchHelpers, Selectors as AssetMonitoringSelectors } from '../../../../../data/assetMonitoring';
import geofencesSelectors from '../../../../../data/geofences/selectors';
import { strings } from '../../../../../localization';
import imgRaven from './images/seen/raven.png';
import RavenUtil from '../../../../common/ravenUtil';
import StatusIcon from '../../../../common/StatusIcon';

const BUTTON_VISIBILITY_ON_MAP_CLASS_NAME = "resource-visibility-on-map";
class Asset extends React.PureComponent {

    state = {
        showMoreGeofences: false,
    }

    componentDidUpdate(prevProps) {
        if(!this.props.selected && this.state.showMoreGeofences) {
            this.setState({showMoreGeofences: false});
        }
    }

    startEditing = () => {
        this.props.setEditingItemName(this.props.assetUuid, true);
    }

    stopEditing = () => {
        this.props.setEditingItemName(this.props.assetUuid, false);
    }

    changeName = (newName) => {
        this.props.setAssetName(newName)
        .catch((err) => {
            console.error("Error changing asset name", err);
            if (this.props.onError) {
                this.props.onError(strings.resource_group_asset_name_change_error);
            }
        });
        this.props.setEditingItemName(this.props.assetUuid, false);
    }

    selectItem = (assetUuid, visible) => {
        this.props.onSelectResource('asset', assetUuid, visible);
    }

    renderLastSeenIcon = () => {
        const { ts, beaconUuid } = this.props.asset;

        if (!beaconUuid) return <span className="no-beacon-assigned">{strings.asset_no_beacon_assigned}</span>;
        const lastSeen = `${strings.asset_last_seen_label}: ` +  (ts ? RavenUtil.toDateString(new Date(ts * 1000)) : strings.asset_never_seen);
        const classes = ts ? "icon-container last-seen" : "icon-container never-seen";
        return (
            <span className={classes}>
                <img src={imgRaven} title={lastSeen} alt={lastSeen} />
            </span>
        );
    }

    toggleMoreGeofences = (e) => {
        e.preventDefault();
        this.setState({showMoreGeofences: !this.state.showMoreGeofences});
    }

    renderBatteryPercentageIcon = () => {

        const { batteryPercentage } = this.props.asset;
        if (batteryPercentage === undefined) {
            // no battery info could be caused by no beacon assigned or beacon not reporting battery
            if (!this.props.asset.beaconUuid) return null;
        };

        const tooltip = batteryPercentage === undefined ? strings.asset_battery_unknown : `${strings.asset_battery}: ${batteryPercentage}%`;
        const classes = batteryPercentage === undefined ? "icon-container battery-life" : "icon-container";

        let iconType = 'battery-0';
        if (batteryPercentage === undefined) iconType = 'battery-unknown';
        else if (batteryPercentage > 75) iconType = 'battery-100';
        else if (batteryPercentage > 50) iconType = 'battery-75';
        else if (batteryPercentage > 25) iconType = 'battery-50';
        else if (batteryPercentage > 0) iconType = 'battery-25';

        return (
            <span className={`${classes} ${iconType}`}>
                <StatusIcon type={iconType} theme="light" title={tooltip} />
            </span>
        )
        
    };

    renderGeofenceIcons = () => {
        const {asset} = this.props;

        if(!asset.latitude || !asset.longitude) return null;

        let geofences = this.props.wrappingGeofences(asset.longitude, asset.latitude);
        
        if (!geofences || geofences.length === 0){
            return null;
        };


        if(geofences.length <= 3) return geofences.map(geofence => this.renderGeofenceIcon(geofence));

        return (
            <>
            <a className="more-geofences" onClick={this.toggleMoreGeofences}><i className="material-icons">{this.state.showMoreGeofences ? 'close' : 'more_horiz'}</i></a>
            {this.state.showMoreGeofences &&
                    geofences.slice(3,6).map(geofence => this.renderGeofenceIcon(geofence)) // render the rest of the geofences (up to 6 due to space constraints)
            }
            {geofences.slice(0, 3).map(geofence => this.renderGeofenceIcon(geofence))}
            </>
        )
    }

    renderGeofenceIcon = (geofence) => {

        const tooltip = `${strings.asset_geofence_label}: ${geofence.name}`;

        return (
            <div className="icon-container goefence" title={tooltip}>
                {geofence.type === 'Polygon' ?
                    <div className="proportionate-polygon small" style={{'--geofence-bgcolor': geofence.color}}><div className='small'></div></div> // https://stackoverflow.com/a/68721147 | use pseudo elements in reactjs as inline styling
                    :
                    <div className="proportionate-circle small" style={{background: geofence.color}}></div>
                }
            </div>
        )
    }

    render() {
        const {
            asset,
            assetUuid,
            selected,
            editingName,
            nameChangePending,
            visible,
            setVisible,
        } = this.props;
        
        const resourceClasses = ["resource"];
        if (selected) resourceClasses.push("selected");

        return (
            <li className={resourceClasses.join(" ")} onClick={ (event) => {
                const parentNode = event.target.parentNode;
                if (parentNode.className &&
                    parentNode.className instanceof String && // "className" can be seemingly unrelated objects for SVG elements
                    parentNode.className.includes(BUTTON_VISIBILITY_ON_MAP_CLASS_NAME)) {
                    this.selectItem(assetUuid, !visible); // visibility is being toggled on this click
                    return;
                }
                this.selectItem(assetUuid, visible);
            }}>
                <header className="resource-header">
                    <h3 className="resource-name">
                        <EditableLabel
                            value={asset.name}
                            editing={editingName}
                            loading={nameChangePending}
                            onRequestEdit={this.startEditing}
                            onChange={this.changeName}
                            onCancel={this.stopEditing}
                            canEdit={this.props.editable}
                        />
                    </h3>
                </header>
                <button className={BUTTON_VISIBILITY_ON_MAP_CLASS_NAME} onClick={() => setVisible(assetUuid, !visible)}>
                    {!visible ?
                        <i className="material-icons unchecked">check_box_outline_blank</i> :
                        <i className="material-icons checked">check_box</i>
                    }
                </button>
                <span className={this.state.showMoreGeofences ? 'status-icons expanded': 'status-icons'}>
                    {this.renderGeofenceIcons()}
                    {this.renderLastSeenIcon()}
                    {this.renderBatteryPercentageIcon()}
                </span>
            </li>
        );
    }
}

Asset.propTypes = {
    asset: PropTypes.object.isRequired,
    assetUuid: PropTypes.string.isRequired,
    editingName: PropTypes.bool.isRequired,
    nameChangePending: PropTypes.bool.isRequired,
    onSelectResource: PropTypes.func.isRequired,
    selected: PropTypes.bool.isRequired,
    setVisible: PropTypes.func.isRequired,
    setAssetName: PropTypes.func.isRequired,
    setEditingItemName: PropTypes.func.isRequired,
    stage: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
};


const mapStateToProps = (state, ownProps) => {
    return {
        asset: AssetMonitoringSelectors.asset(state, ownProps.assetUuid),//assets.Selectors.asset(state, ownProps.assetUuid),
        nameChangePending: AssetMonitoringSelectors.assetNameChangePending(state, ownProps.assetUuid),//assets.Selectors.assetNameChangePending(state, ownProps.assetUuid),
        visible: AssetMonitoringSelectors.isAssetVisible(state, ownProps.assetUuid),//assets.Selectors.isAssetVisible(state, ownProps.assetUuid),
        wrappingGeofences: (log, lat) => geofencesSelectors.wrappingGeofences(state, [log, lat]),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setAssetName: name => dispatch(AssetMonitoringDispatchHelpers.setAssetName(ownProps.assetUuid, name))//dispatch(assets.Actions.setAssetName(ownProps.stage, ownProps.assetUuid, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Asset);
export { Asset as UnconnectedAsset }; // Added for testing
